import { createReducer, on } from '@ngrx/store';
import { Negotiation } from 'src/app/components/negotiations/negotiations.model';
import { fetchNegotiations, newNegotiationData } from './negotiations.actions';

export interface NegotiationsState {
  negotiations: Negotiation[] | null;
}

export const initialNegotiationsState = {
  negotiations: null,
};

export const negotiationsReducer = createReducer(
  initialNegotiationsState,
  on(fetchNegotiations, (state) => ({ ...state })),
  on(newNegotiationData, (state, { negotiations }) => ({
    negotiations: [...negotiations],
  }))
);
